export const SEVERITY_TYPES = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};
